import { Alert, Button, TextField } from "@mui/material";
import Logger from "../../services/Logger";
import Box from "@mui/material/Box";
import React, { useState } from "react";
import { decryptText, encryptText } from "../../services/CryptoUtil";

export default function CryptoMain() {
    const [plainText, setPlainText] = useState(""); // Store the plain text input
    const [encryptedText, setEncryptedText] = useState(""); // Store the encrypted text
    const [decryptedText, setDecryptedText] = useState(""); // Store the decrypted text
    const [comparisonResult, setComparisonResult] = useState(null); // Store comparison result: 'match' or 'mismatch'

    const handleEncrypt = async () => {
        try {
            // Encrypt the plain text
            const encrypted = await encryptText(plainText);
            Logger.log("Encrypted Text by CryptoUtil:", encrypted);
            setEncryptedText(encrypted);
            setComparisonResult(null); // Clear comparison result when encrypting
        } catch (error) {
            Logger.error("Error during encryption:", error);
        }
    };

    const handleDecrypt = async () => {
        try {
            // Check if encrypted text is empty
            if (!encryptedText || !encryptedText.trim()) {
                Logger.error("Encrypted text is empty");
                alert("Please enter encrypted text to decrypt");
                return;
            }

            Logger.log("Attempting to decrypt:", encryptedText.substring(0, 50) + "...");
            
            // Decrypt the encrypted text
            const decrypted = decryptText(encryptedText.trim());
            Logger.log("Decrypted Text:", decrypted);
            
            if (!decrypted) {
                Logger.error("Decryption returned null or empty");
                alert("Decryption failed. Please check if the encrypted text is valid.");
                setDecryptedText("");
                setComparisonResult(null);
                return;
            }

            setDecryptedText(decrypted);

            // Compare decrypted text with plain text (only if plain text exists)
            if (plainText) {
                if (decrypted === plainText) {
                    setComparisonResult('match');
                } else {
                    setComparisonResult('mismatch');
                }
            } else {
                // If no plain text, just show success for successful decryption
                setComparisonResult(null);
            }
        } catch (error) {
            Logger.error("Error during decryption:", error);
            alert("Error during decryption: " + error.message);
            setDecryptedText("");
            setComparisonResult(null);
        }
    };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, width: "100%" }}>
            <TextField
                label="Plain Text"
                variant="outlined"
                value={plainText}
                onChange={(e) => {
                    setPlainText(e.target.value);
                    setComparisonResult(null); // Clear comparison result when plain text changes
                }}
                fullWidth
                multiline
                rows={8}
            />
            <Box>
                <Button variant="contained" onClick={handleEncrypt}>
                    Encrypt
                </Button>
            </Box>
            <TextField
                label="Encrypted Text"
                variant="outlined"
                value={encryptedText}
                onChange={(e) => {
                    setEncryptedText(e.target.value);
                    setComparisonResult(null); // Clear comparison result when encrypted text changes
                }}
                fullWidth
                multiline
                rows={8}
            />
            <Box>
                <Button variant="contained" onClick={handleDecrypt}>
                    Decrypt
                </Button>
            </Box>
            {comparisonResult === 'match' && (
                <Alert severity="info">
                    OK - Decrypted text matches the plain text
                </Alert>
            )}
            {comparisonResult === 'mismatch' && (
                <Alert severity="warning">
                    Warning - Decrypted text does not match the plain text
                </Alert>
            )}
            <TextField
                label="Decrypted Text"
                variant="outlined"
                value={decryptedText}
                fullWidth
                disabled
                multiline
                rows={8}
            />
        </Box>
    );
}
